import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { Context } from '../../App';
import { API } from '../../conf';

const CancelDepense = ({ depense, setLoad, updateDepenses, onCancel }) => {
    const { updateConnect } = React.useContext(Context);
    
    const onConfirm = () => {
        setLoad(true);
        const queryParams = new URLSearchParams({_id: depense._id}).toString();
        fetch(API.concat(`/depenses?${queryParams}`), {
            method:'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json();
                    updateDepenses(json)
                    onCancel()
                }
                setLoad(false)
            }
        })
        onCancel();
    };

    return (
        <Box
            sx={{p:3, textAlign: 'center',}}
        >
            <Typography variant="h6" gutterBottom>
                Voulez-vous vraiment annuler cette dépense?
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
                <Button variant="contained" color="error" onClick={onConfirm}>
                    Oui
                </Button>
                <Button variant="outlined" onClick={onCancel}>
                    Non
                </Button>
            </Stack>
        </Box>
    );
}

export default CancelDepense;